import { CorsairActionRecord } from '@/model';

import { BaseHttpController } from './BaseHttpController';

export class ActionLogController extends BaseHttpController {
  static readonly ENDPOINT: string = 'action-log';

  constructor() {
    super(ActionLogController.ENDPOINT);
  }

  async findOrderActions(orderId: number): Promise<CorsairActionRecord[]> {
    const response = await this.http.get<CorsairActionRecord[]>(
      `Order/${orderId}`,
    );
    return response.data.map((val) => new CorsairActionRecord(val));
  }

  async findShipmentActions(
    shipmentId: number,
  ): Promise<CorsairActionRecord[]> {
    const response = await this.http.get<CorsairActionRecord[]>(
      `Shipment/${shipmentId}`,
    );
    return response.data.map((val) => new CorsairActionRecord(val));
  }
}
